import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {
  ResourcesProvider,
} from "./Providers/ResourcesProvider/ResourceProvider";
import Page404 from "./404page";
import SicceLanding from "./Pages/SicceLanding";
import FogSolutionLanding from "./Pages/FogSolutionLanding";
import FogSolutionPP from "./Pages/FogSolutionPP";

import routes from "./Risorse/routes";
import { URLs } from "./Risorse/routes";

const findDefaultLanguage = (productKey) => {
  const availableLangs = Object.keys(URLs[productKey].langs).sort(
    (a, b) => a.length - b.length,
  );
  const fullLang = navigator?.language?.replace("-", "_").toLowerCase();

  if (fullLang) {
    for (const lang of availableLangs) {
      if (fullLang.match(lang)) return lang;
    }
  }
  return "en";
};

const PAGES = {
  sicce: SicceLanding,
  fogsolution: FogSolutionLanding,
};

export default function App() {
  return (
    <div>
      <Router>
        <Routes>
          {Object.entries(routes).map(([page, pageRoutes]) => {
            if (page === "404") return null;
            const Component = PAGES[page];
            if (!Component) return null;
            if (!pageRoutes?.langs) return null;

            return Object.entries(pageRoutes.langs).map(([lang, path]) => (
              <Route
                key={`${page}-${lang}`}
                path={path}
                element={
                  <ResourcesProvider
                    language={lang}
                    product={page}
                    localization={URLs[page]?.langs}
                  >
                    <Component />
                  </ResourcesProvider>
                }
              />
            ));
          })}

          {Object.entries(routes).map(([product, productRoutes]) => {
            if (!productRoutes?.home) return null;
            return (
              <Route
                key={`${product}-home`}
                path={productRoutes.home}
                element={
                  <Navigate
                    to={`${productRoutes.home}/${findDefaultLanguage(product)}`}
                  />
                }
              />
            );
          })}

          <Route
            path="/"
            element={
              <Navigate
                to={`${routes.sicce.home}/${findDefaultLanguage("sicce")}`}
              />
            }
          />
          <Route
            path={routes.fogsolutionPrivacyPolicy}
            element={
              <ResourcesProvider
                language={findDefaultLanguage("fogsolution")}
                product="fogsolution"
                localization={URLs.fogsolution.langs}
              >
                <FogSolutionPP />
              </ResourcesProvider>
            }
          />
          <Route path={routes[404]} element={<Page404 />} />
          <Route path="*" element={<Navigate to={routes[404]} />} />
        </Routes>
      </Router>
    </div>
  );
}
